import React from 'react'
import Experience from '../components/home/Experience'

import MainPageLayout from '../components/MainPageLayout'

const Experiences = () => {
  return (
    <MainPageLayout>
          <Experience />
    </MainPageLayout>
  )
}

export default Experiences